// import { SMS } from '@ionic-native/sms';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the CarismsgonderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-carismsgonder',
  templateUrl: 'carismsgonder.html',
})
export class CarismsgonderPage {
  vWKayit: any = {};
  kayit:any={};
   textsms="";
   numara="";

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public viewCtrl:ViewController,
    // private sms:SMS,
     public navParams: NavParams) {
      if (navParams.get("vWKayit") != null) {
        this.vWKayit = navParams.get("vWKayit");
        var data = new FormData();
        data.append("Cari_id", this.vWKayit.ID);
        this.bllOrtak.islem(data, "CariGetirByID", "", false).then(a => {
          var Sonuc = <any>a;
          this.kayit = Sonuc.SonucObject;
          this.numara=this.kayit.GsmNo;
        
        }
        )
    
      }
  }


  gonder()
  {

 //   this.sms.send(this.numara,this.textsms);
    this.viewCtrl.dismiss();
  }
  kapat(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/CariIslemleri/carismsgonder/carismsgonder.ts